(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["carousel"] && !window.DesignMode) return;
  try {
    
  var slide = 0;

  function onSliderSectionAdjust(a) {
    if(!a) return;
    window.sliders = window.sliders || {};
    window.sliders[a.detail.sectionId]();
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }
  function onSliderBlockAdjust(a) {
    if(!a) return;
    var block = $('.slide--'+a.detail.blockId);
    slide = parseInt(block.attr("data-index"));
    $('.slider--'+a.detail.sectionId).slick('slickGoTo', slide);
  }

  $(document).on('shopify:section:load', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:select', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:section:reorder', '.carousel', onSliderSectionAdjust);
  $(document).on('shopify:block:select', '.carousel', onSliderBlockAdjust);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vd-pop-up"] && !window.DesignMode) return;
  try {
    
 (function(){
  
  const modal = document.getElementById("vd-popup-modal");
  const modalContent = document.querySelectorAll("#vd-popup-modal .modal-content");  
  const btnClose = document.querySelectorAll("#vd-popup-modal .close")[0];
  let exitCounter = 0;
  
  // options generique  
  // taille max de la popup
  const popupMaxWith = "800px"; 
  
  // options mobile
  // délay de déclenchement de la popup sur mobile
  const delayMobile = "15000" // millisecondes
  
  modalContent[0].style.maxWidth = popupMaxWith;
  
 
  btnClose.onclick = function() {
    modal.style.display = "none";
  }
  
  if (window.matchMedia("(min-width: 768px)").matches) {

    document.addEventListener("mouseleave", function(event){
      if(event.clientY <= 0 || event.clientX <= 0 || (event.clientX >= window.innerWidth || event.clientY >= window.innerHeight)) {
        if(exitCounter < 2) {
          exitCounter++;
        }     
        if(exitCounter == 1) {
          dgOpenPopup();
        }
      }
    });
    
  }
  else {    
    // faire ouverture de popup x secondes
    setTimeout(function() {
       dgOpenPopup();      
    }, delayMobile);
    
  }
 
  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  }
  
 function dgOpenPopup() {
  // Vérifiez d'abord si la pop-up a déjà été montrée aujourd'hui
  var lastShown = localStorage.getItem("popupLastShown");
  var now = new Date();

  if (lastShown) {
    var diff = now - new Date(lastShown);
    var diffInHours = diff / 1000 / 60 / 60;

    // Si la pop-up a été montrée il y a moins de 24 heures, ne faites rien
    if (diffInHours < 24) {
      return;
    }
  }

  // Sinon, montrez la pop-up et mettez à jour le moment où elle a été montrée pour la dernière fois
  modal.style.display = "block";
  modal.classList.add("show");
  modal.classList.remove("hide");
  document.body.scrollTop = 0; 
  document.documentElement.scrollTop = 0;
  
  localStorage.setItem("popupLastShown", now);
}
btnClose.onclick = function() {
  modal.classList.add("hide");
  modal.classList.remove("show");
  setTimeout(function() { modal.style.display = "none"; }, 500); // correspond au temps de l'animation fadeOut
}
   
})();

  } catch(e) { console.error(e); }
})();

})();
